module.exports = __webpack_public_path__ + "img/phone-icon.a2c3fcf3.png";